module.exports = __webpack_public_path__ + "img/PC.e5c180af.png";